// Fusión de lotes de productos sobre una lista ya renderizada. Fuente ÚNICA para
// App e Inventario — los dos reciben el mismo refresco silencioso por SSE y no
// pueden derivar en cómo lo aplican.
//
// Contexto (S2b): una venta hecha desde otro dispositivo llega por SSE y dispara
// un refetch. Ese refetch traía el lote 1 y hacía `setProducts(lote1)`, o sea que
// a quien estuviera mirando se le vaciaba la lista (Catálogo 30 → 10 filas,
// Inventario 30 → 24) sin haber tocado nada.

// Funde un lote entrante sobre la lista que ya está en pantalla: los productos
// que ya existen se ACTUALIZAN en su sitio y los nuevos se agregan al final (el
// orden final lo pone el sort de cada módulo, no este array). Nunca encoge.
//
// Contrapartida asumida: por esta vía un producto BORRADO en Woo se queda en la
// lista hasta la próxima carga normal (entrar al módulo o F5). Se prefiere eso a
// vaciarle la lista a quien está trabajando.
export function fusionarPorId(prev, entrantes) {
  if (!entrantes.length) return prev;
  const porId = new Map(entrantes.map((p) => [p.id, p]));
  const fundidos = prev.map((p) => porId.get(p.id) || p);
  const yaEstaban = new Set(prev.map((p) => p.id));
  const nuevos = entrantes.filter((p) => !yaEstaban.has(p.id));
  return nuevos.length ? fundidos.concat(nuevos) : fundidos;
}

// Un lote de la carga normal REEMPLAZA (es una lista nueva desde cero); uno de un
// refresco silencioso se FUNDE.
export function aplicarLote(prev, entrantes, silent) {
  return silent ? fusionarPorId(prev, entrantes) : entrantes;
}
